module.exports = __webpack_public_path__ + "static/media/MTNLogo.e29098e7.svg";